function mgCheckStatus() {
  // let actionButton = document.querySelectorAll('.mg-table__body--click')
  if (document.querySelector('.Tabs') != null) {
    let tabs = document.querySelector('.Tabs')

    let actionButton = tabs.querySelectorAll('[data-order]')
    let parentList = tabs.querySelectorAll('.mg-check-status__container')
  
    actionButton.forEach((item, id) => {
      item.addEventListener('click', () => {
        let list = parentList[id]
        let listItem = list.querySelectorAll('.mg-check-status__block')
        for (let i = listItem.length - 1; i >= 0; i--) {
          if ((list.getAttribute('data-error') / 1) === 0) {
            if (i < (list.getAttribute('data-status') / 1)) {
              listItem[i].classList.add('mg-status-green')
            }
          } else if ((list.getAttribute('data-error') / 1) === 1){
            if (i < (list.getAttribute('data-error') / 1)) {
              listItem[listItem.length - 1].removeAttribute('style')
              listItem[listItem.length - 1].classList.add('mg-status-red')
            }
          }
        }
      })
    })
  }


  // actionButton.forEach(parent => {
  //   parent.addEventListener('mousedown', () => {
  //     let parentList = parent.querySelector('.mg-check-status__container')
  //     let list = parentList.querySelectorAll('.mg-check-status__block')

  //     for (let i = list.length - 1; i >= 0; i--) {
  //       if (i <= (parentList.getAttribute('data-status') / 1)) {
  //         list[i].classList.add('mg-status-green')
  //       }
  //     }
  //   })
  // })
}
// function mgCheckStatus() {
//   const statusName = document.querySelectorAll('[data-status-check]');
//   const mgStatusBlock = document.querySelectorAll('.mg-status');
//   try {

//     const drawGreen = (num) => {
//       for (let j = 0; j <= num; j++) {
//         mgStatusBlock[num]
//           .querySelectorAll('.mg-check-status__block')
//           [j].classList.add('mg-status-green');
//       }
//     };

//     statusName.forEach((el, i) => {
//       const status = el.getAttribute('data-status-check');

//       switch (status) {
//         case 'new':
//           el.innerText = 'Новый';
//           drawGreen(i);
//           break;
//         case 'accepted':
//           el.innerText = 'Принят';
//           drawGreen(i);
//           break;
//         case 'agreed':
//           el.innerText = 'Согласован';
//           drawGreen(i);
//           break;
//         case 'partially-shipped':
//           el.innerText = 'Частично отгружен';
//           drawGreen(i);
//           break;
//         case 'shipped':
//           el.innerText = 'Отгружен';
//           drawGreen(i);
//           break;
//         case 'completed':
//           el.innerText = 'Выполнен';
//           drawGreen(i);
//           break;
//         default:
//           break;
//       }
//     });
//   } catch (err) {
//   }
// }
